/**
 * RFC 표준에서 Header 는 case-insensitive 하다. 그래서 대소문자가 맘대로 들어올 수 있으니 Node.js, Axios 등에선 header 구문 분석을 위해 lowercase 로 강제 변환한다. 그러니 헤더값을 가져올 땐 lowercase 로 가져와야한다.
 */
export enum HttpHeaderKey {
  ContentType = 'content-type',
  Cookie = 'cookie',
  UserAgent = 'user-agent',
  Accept = 'accept',
  AcceptLanguage = 'accept-language',
  HintUa = 'sec-ch-ua',
  HintPlatform = 'sec-ch-ua-platform',
}

export enum MimeType {
  ApplicationJson = 'application/json; charset=utf-8',
  TextHtml = 'text/html; charset=utf-8',
  FormUrlEncoded = 'application/x-www-form-urlencoded',
}
export const GLOBAL_ONLY_PATHS = [
  '(login|signup)$',
  'global-policy($|/)', // global-policy 하위 모든 경로
  'account/find-password$',
  'auth/age/verify/start$',
];
export const GLOBAL_PATHS_REGEX = new RegExp(
  `^/(${GLOBAL_ONLY_PATHS.join('|')})`
);
